// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a67a44e9","667":"13b362c4","977":"4a2fd160"}[chunkId] + ".chunk.js";
};